import { DeleteIcon } from 'components/icons';
import querystring from 'querystring';
import {
  useGetStoreInfoQuery,
  useRemoveStoreMemberMutation,
} from 'store/services/segmentsApi';

/**
 *
 * @param {{member: import('store/services/types').User,isMemberAdmin:boolean,storeName:string}} member
 * @returns
 */
export default function TeamMember({
  member,
  isMemberAdmin = false,
  storeName,
}) {
  const queryParams = querystring.stringify({
    store_name: storeName,
  });

  const { data } = useGetStoreInfoQuery(queryParams, { skip: !!!storeName });
  const [removeMember, { isLoading }] = useRemoveStoreMemberMutation();

  const handleDelete = () => {
    const memberInfo = {
      serializedStoreName: queryParams,
      storeId: Number(data?.id),
      memberId: Number(member.id),
    };

    removeMember(memberInfo);
  };
  return (
    <tr>
      <td className="py-2 text-base font-normal">{member?.name ?? '--'}</td>
      <td className="hidden text-base font-normal md:block">
        {member?.email ?? '--'}
      </td>
      <td className="text-base font-normal ">{member?.role_name ?? '--'}</td>
      <td className="text-base font-normal">
        <button
          aria-label="delete"
          className="block disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none"
          disabled={!!!isMemberAdmin}
          title={
            !!!isMemberAdmin
              ? 'Only Admin can delete a member'
              : 'Delete a member'
          }
          onClick={handleDelete}
        >
          <DeleteIcon
            className={`w-5 h-5 text-black ${isLoading && 'animate-spin'}`}
          />
        </button>
      </td>
    </tr>
  );
}
